import { render, staticRenderFns } from "./PresentationRequests.vue?vue&type=template&id=379cc3f5&scoped=true"
import script from "./PresentationRequests.vue?vue&type=script&lang=js"
export * from "./PresentationRequests.vue?vue&type=script&lang=js"
import style0 from "./PresentationRequests.vue?vue&type=style&index=0&id=379cc3f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379cc3f5",
  null
  
)

export default component.exports